import { EventBus } from "../eventbus";

export const deleteSelected = (vueThis) => {
  const selected = vueThis.$store.state.transferItems;

  EventBus.$emit(`right-sidebar-show`, {
    id: "delete",
    data: [...selected.selectedFiles, ...selected.selectedFolders],
  });
};
